import { timeFormat, timeParse } from 'd3-time-format';
import { internalUnits, mmolL, mgdL } from './consts';
import { glucoseMolarMass, glucoseAccessor } from './dataUtils';

// These are not translated, rather used internally
export const dateNames = Object.freeze(
  ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);

/* 
  %U - Sunday-based week of the year as a decimal number [00,53].
  %V - ISO 8601 week of the year as a decimal number [01, 53].
  %W - Monday-based week of the year as a decimal number [00,53].
*/

//export const dateNameFormat = timeFormat('%A');
export const parseDate = timeParse('%Y-%m-%d');
export const urlDateFormat = timeFormat('%Y-%m-%d');
//export const dateFormat = timeFormat('%x');
//export const dayTimeFormat = timeFormat('%H:%M');
export function datetimeDurationFormat(minutes) {
  return `PT${minutes >= 60 ? `${Math.floor(minutes / 60)}H` : ''}${minutes % 60}M`;
}

// This should (and will!) be implemented with a proper translation library...
export function formatGlucoseUnits(units = internalUnits) {
  switch (units.toLowerCase()) {
    case mmolL:
      // TODO: localize between mmol/l and mmol/L ?
      return 'mmol/l';
    case mgdL:
      return 'mg/dL';
    default:
      return '???';
  }
}

export function formatGlucoseValue(glucose, units = internalUnits) {
  if (!glucose) {
    return '?';
  }
  let value;
  try {
    value = glucoseAccessor(glucose);
    if (units !== internalUnits) {
      if (internalUnits === mmolL) {
        // Need to convert to mg/dL
        value *= glucoseMolarMass;
      } else {
        // Need to convert to mmol/l
        value /= glucoseMolarMass;
      }
    }
  } catch (error) {
    return '?';
  }
  // Present the converted value in specified precision
  return value.toFixed(units.toLowerCase() === mmolL ? 1 : 0);
}

export function formatGlucose(glucose, units = internalUnits) {
  return `${formatGlucoseValue(glucose, units)} ${formatGlucoseUnits(units)}`;
}
